<template>
  <div style="margin-top: 15px;">
    <v-row>
      <col12>
        <v-btn 
          small 
          color="secondary" 
          @click.native="saveCurrentFilter"
          :disabled="!canSave"
          style="margin-right: 10px;"
        >
          {{ $t('filter_save_load.btn_save') }}
        </v-btn>
        <v-menu offset-y v-if="savedFilters.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('filter_save_load.btn_load') }}
              <v-icon small right>fas fa-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(filter, index) in savedFilters"
              :key="index"
              style="cursor: pointer"
            >
              <v-list-item-title @click="loadFilter(filter)">
                {{ filter.name }}
              </v-list-item-title>
              <v-list-item-action>
                <v-btn
                  icon
                  small
                  @click.native.stop="deleteFilter(filter.id)"
                >
                  <v-icon small color="error">fas fa-trash</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </col12>
    </v-row>
  </div>
</template>

<script>
import Col12 from "@/components/layout/Col12";
const { v4: uuidV4 } = require('uuid');

export default {
  name: "FilterSaveLoad",
  components: { Col12 },
  props: {
    filters: {
      type: [Array, Boolean],
      default: () => []
    },
    limit: {
      type: [Number, Boolean],
      default: 12
    },
    pageName: {
      type: String,
      required: true
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['user/get_current_user'];
    },
    storageKey() {
      if (!this.currentUser) return null;
      return `filter_saves_${this.pageName}_${this.currentUser.id}`;
    },
    savedFilters() {
      if (!this.storageKey) return [];
      try {
        const saved = localStorage.getItem(this.storageKey);
        return saved ? JSON.parse(saved) : [];
      } catch (e) {
        console.error('Error loading saved filters:', e);
        return [];
      }
    },
    canSave() {
      return Array.isArray(this.filters) && this.filters.length > 0 && this.currentUser;
    }
  },
  methods: {
    saveCurrentFilter() {
      if (!this.canSave || !this.storageKey) return;
      
      const filterName = prompt(this.$t('filter_save_load.prompt_name') || 'Enter a name for this filter:');
      if (!filterName || !filterName.trim()) return;
      
      const savedFilters = [...this.savedFilters];
      const newFilter = {
        id: uuidV4(),
        name: filterName.trim(),
        filters: JSON.parse(JSON.stringify(this.filters)), // Deep copy
        limit: this.limit,
        savedAt: new Date().toISOString()
      };
      
      savedFilters.push(newFilter);
      localStorage.setItem(this.storageKey, JSON.stringify(savedFilters));
      
      this.$emit('saved', newFilter);
    },
    loadFilter(filter) {
      this.$emit('load', filter.filters, filter.limit);
    },
    deleteFilter(filterId) {
      if (!this.storageKey) return;
      
      if (confirm(this.$t('filter_save_load.confirm_delete') || 'Are you sure you want to delete this filter?')) {
        const savedFilters = this.savedFilters.filter(f => f.id !== filterId);
        localStorage.setItem(this.storageKey, JSON.stringify(savedFilters));
        this.$emit('deleted', filterId);
      }
    }
  }
}
</script>

<style scoped>
</style>

